import React, { Component } from 'react';
import { TweenLite } from 'gsap';

import { crossfade } from '../../lib/data';

import AppStore from '../../lib/flux/AppStore';
import AppActions from '../../lib/flux/AppActions';
import AppActionTypes from '../../lib/flux/AppActionTypes';

import './Crossfade.scss';

const duration = 1;
const pause = duration * 3;

class Crossfade extends Component {
    constructor(props) {
        super(props);
        this.state = {
            left: 0,
            right: 0,
            visible: false,
            loaded: { left: true, right: true }
        }
    }

    componentDidMount() {
        AppStore.on(AppActionTypes.ANIMATION, this._handleStoreAnimationChange);
    }

    componentWillUnmount() {
        AppStore.removeListener(AppActionTypes.ANIMATION, this._handleStoreAnimationChange);
    }

    _handleStoreAnimationChange = ({ intro }) => {
        this.setState({ visible: intro }, () => {
            if (this.state.visible) {
                this.in();
            }
        });
    }

    in = () => {
        TweenLite.set(this.refs.left, {
            opacity: 0, onComplete: () => {
                this.leftIn({ start: true });
            }
        });
        TweenLite.set(this.refs.right, {
            opacity: 0, onComplete: () => {
                this.rightIn({ start: true, delay: duration });
            }
        });
    }

    leftIn = ({ start }) => {
        // console.log('leftIn()', { start });
        const { loaded } = this.state;
        if (!loaded.left || start) {
            TweenLite.set(this.refs.left, {
                opacity: 0, onComplete: () => {
                    TweenLite.to(this.refs.left, duration, {
                        css: { opacity: "1" }, ease: 'easeOutCubic', delay: 0, onComplete: () => {
                            // console.log('setting loaded for left');
                            this.setState({ loaded: Object.assign(loaded, { left: true }) });
                        }
                    });
                }
            });
        }

    }

    rightIn = ({ start = false, delay = 0 }) => {
        // console.log('rightIn()', { start, delay });
        const { loaded } = this.state;
        TweenLite.set(this.refs.right, {
            opacity: 0, onComplete: () => {
                if (!loaded.right || start) {
                    TweenLite.to(this.refs.right, duration, {
                        css: { opacity: "1" }, ease: 'easeOutCubic', delay, onComplete: () => {
                            // console.log('setting loaded for right to true and pausing');
                            this.setState({ loaded: Object.assign(loaded, { right: true }) }, this.pause);
                        }
                    });
                }
            }
        });
    }

    leftOut = () => {
        // console.log('leftOut()')
        TweenLite.to(this.refs.left, duration, {
            css: { opacity: "0" }, ease: 'easeInCubic', delay: 0, onComplete: () => {
                const { left, loaded } = this.state;
                let next = left + 1;
                if (next >= crossfade.list.length) {
                    next = 0;
                }
                // console.log('removing loaded for left and loading next index', next);
                this.setState({ left: next, loaded: Object.assign(loaded, { left: false }) });
            }
        });
    }

    rightOut = () => {
        // console.log('rightOut()');
        TweenLite.to(this.refs.right, duration, {
            css: { opacity: "0" }, ease: 'easeInCubic', delay: duration, onComplete: () => {
                const { right, loaded } = this.state;
                let next = right + 1;
                if (next >= crossfade.list.length) {
                    next = 0;
                }
                // console.log('removing loaded for right and loading next index', next);
                this.setState({ right: next, loaded: Object.assign(loaded, { right: false }) });
            }
        });
    }

    pause = () => {
        // console.log('pause()');
        setTimeout(() => {
            // console.log('pause settimeout');
            this.leftOut();
            this.rightOut();
        }, pause * 1000)
    }

    render() {
        const { left, right, visible } = this.state;

        return (
            <div className={`crossfade-container ${!visible ? 'hidden' : ''}`}>
                <div className={'crossfade-left-container'} ref={'left'}>
                    <img src={crossfade.list[left].left} alt={'speaker-left'} className={'crossfade-left-image'} onLoad={() => {
                        // console.log('left image loaded', left);
                        this.leftIn({ start: false });
                    }} />
                </div>
                <div className={'crossfade-right-container'} ref={'right'}>
                    <img src={crossfade.list[right].right} alt={'speaker-right'} className={'crossfade-right-image'} onLoad={() => {
                        // console.log('right image loaded', right);
                        this.rightIn({ start: false });
                    }} />
                </div>
            </div>
        );
    }
}

export default Crossfade;